import{a as e,b as r}from"./chunk-JFFVMJIA.mjs";import"./chunk-ZS6VBONO.mjs";import"./chunk-AQ6EADP3.mjs";export{e as ArchitectureModule,r as createArchitectureServices};
